import { TextField, WithStyles } from '@material-ui/core';
import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import { InjectedFormikProps, withFormik } from 'formik';
import * as React from 'react';
import * as Yup from 'yup';
import MyButton from '../../../components/UI/MyButton/MyButton';
import { IAgent } from '../../../models/states';

const styles = (theme: Theme) =>
  createStyles({
    root: {},
    textField: {
      margin: '0',
      marginBottom: '1rem',
      width: '100%'
    },
    marginTop: {
      marginTop: '1rem'
    },
    inputField: {
      width: '20rem'
    }
  });

interface IFormValues {
  customer: string;
}

interface IFormProps extends WithStyles<typeof styles> {
  agent?: IAgent;
  onSubmit: (values: any) => void;
}

const InnerForm: React.SFC<
  InjectedFormikProps<IFormProps, IFormValues>
> = props => (
  <div>
    <form onSubmit={props.handleSubmit}>
      <div className={props.classes.inputField}>
        <TextField
          id="customer"
          label="Customer Name"
          placeholder="xxx.amagi.tv"
          className={props.classes.textField}
          value={props.values.customer}
          onChange={props.handleChange}
          error={Boolean(props.errors.customer && props.touched.customer)}
          helperText={
            props.errors.customer &&
            props.touched.customer &&
            String(props.errors.customer)
          }
          margin="normal"
          name="customer"
          InputLabelProps={{
            shrink: true
          }}
        />
      </div>
      <MyButton
        btnType={'yellow'}
        className={classNames(props.classes.textField, props.classes.marginTop)}
        type="submit"
        disabled={props.isSubmitting}
      >
        Save
      </MyButton>
    </form>
  </div>
);

const AgentForm = withFormik<IFormProps, IFormValues>({
  mapPropsToValues: props => {
    return {
      customer: props.agent ? props.agent.customer : ''
    };
  },
  validationSchema: Yup.object().shape({
    customer: Yup.string().required('*Required')
  }),
  validate: () => {
    const errors: any = {};

    return errors;
  },

  handleSubmit: (values, { props }) => {
    values.customer = values.customer
      .toLowerCase()
      .trim()
      .replace(/\s+/g, '-')
      .replace(/[^0-9a-zA-Z.-]/g, '');
    props.onSubmit(values);
  }
})(InnerForm);

export default withStyles(styles)(AgentForm);
